(() => {
  const getCatalogGrid = () => document.querySelector('#product-grid[data-catalog-grid]');
  const catalogCategoryNames = ['catalog', 'merch', 'books', 'bootlegs', 'digital'];
  let selectedCatalogCategories = new Set();

  const applyCatalogCategoryFilter = () => {
    document.querySelectorAll('[data-catalog-category-param]').forEach((input) => {
      input.value = Array.from(selectedCatalogCategories).join(',');
      input.disabled = selectedCatalogCategories.size === 0;
    });

    document.querySelectorAll('[data-catalog-category-section]').forEach((section) => {
      section.hidden = selectedCatalogCategories.size > 0 && !selectedCatalogCategories.has(section.dataset.catalogCategorySection);
    });
  };

  const initializeCatalogCategoryFilter = () => {
    const inputs = Array.from(document.querySelectorAll('[data-catalog-category-filter]'));
    if (!inputs.length) return;

    const requestedCategories = new URLSearchParams(window.location.search).get('catalog_category');
    selectedCatalogCategories = new Set((requestedCategories || '').split(',')
      .map((category) => category === 'music' ? 'catalog' : category)
      .filter((category) => catalogCategoryNames.includes(category)));

    inputs.forEach((input) => {
      input.checked = selectedCatalogCategories.has(input.dataset.catalogCategoryFilter);
    });
    applyCatalogCategoryFilter();
  };

  window.addEventListener('popstate', initializeCatalogCategoryFilter);

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-catalog-category-filter]');
    if (!input) return;

    const category = input.dataset.catalogCategoryFilter;
    if (input.checked) {
      selectedCatalogCategories.add(category);
    } else {
      selectedCatalogCategories.delete(category);
    }

    document.querySelectorAll('[data-catalog-category-filter]').forEach((categoryInput) => {
      categoryInput.checked = selectedCatalogCategories.has(categoryInput.dataset.catalogCategoryFilter);
    });
    applyCatalogCategoryFilter();
  }, true);

  const initializeCatalog = (root = document) => {
    const grid = root.querySelector('#product-grid[data-catalog-grid]') || getCatalogGrid();
    const groups = root.querySelector('[data-catalog-groups]') || document.querySelector('[data-catalog-groups]');
    if (!grid || !groups) return;

    const categoryGrids = {
      catalog: groups.querySelector('[data-catalog-category-grid="catalog"]'),
      merch: groups.querySelector('[data-catalog-category-grid="merch"]'),
      books: groups.querySelector('[data-catalog-category-grid="books"]'),
      bootlegs: groups.querySelector('[data-catalog-category-grid="bootlegs"]'),
      digital: groups.querySelector('[data-catalog-category-grid="digital"]'),
    };
    if (Object.values(categoryGrids).some((categoryGrid) => !categoryGrid)) return;

    const placeItemInCategories = (item) => {
      const category = categoryGrids[item.dataset.catalogCategory] ? item.dataset.catalogCategory : 'catalog';
      categoryGrids[category].appendChild(item);
      if (item.dataset.catalogAlsoBooks === 'true' && category !== 'books') {
        categoryGrids.books.appendChild(item.cloneNode(true));
      }
    };

    const sortMerchGrid = () => {
      const getPriority = (item) => {
        const title = item.dataset.catalogTitle || '';
        if (!title.includes('2026')) return 2;
        if (!title.includes('t-shirt')) return 1;
        if (title.includes('white')) return 0;
        if (title.includes('blue')) return 0.1;
        return 0.2;
      };

      Array.from(categoryGrids.merch.children)
        .map((item, index) => ({ item, index, priority: getPriority(item) }))
        .sort((left, right) => left.priority - right.priority || left.index - right.index)
        .forEach(({ item }) => categoryGrids.merch.appendChild(item));
    };

    grid.querySelectorAll(':scope > .grid__item').forEach((item) => {
      placeItemInCategories(item);
    });
    sortMerchGrid();
    grid.hidden = true;
    groups.hidden = false;
    initializeCatalogCategoryFilter();

    const loadMoreButton = root.querySelector('[data-catalog-load-more]') || document.querySelector('[data-catalog-load-more]');
    const pagination = root.querySelector('[data-catalog-pagination]') || document.querySelector('[data-catalog-pagination]');
    const loadMoreWrapper = loadMoreButton?.closest('.catalog-load-more');
    const loadStatus = loadMoreWrapper?.querySelector('[data-catalog-load-status]');

    if (loadMoreButton) {
      if (!loadMoreButton.dataset.nextUrl) {
        loadMoreWrapper.hidden = true;
      } else {
        loadMoreButton.hidden = false;
        if (pagination) pagination.hidden = true;
      }

      if (loadMoreButton.dataset.initialized !== 'true' && loadMoreButton.dataset.nextUrl) {
        loadMoreButton.addEventListener('click', async () => {
          if (loadMoreButton.disabled || !loadMoreButton.dataset.nextUrl) return;

          const nextUrl = new URL(loadMoreButton.dataset.nextUrl, window.location.origin);
          nextUrl.hash = '';
          loadMoreButton.disabled = true;
          if (loadStatus) loadStatus.textContent = 'Loading more products.';

          try {
            const response = await fetch(nextUrl.toString(), {
              credentials: 'same-origin',
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
            });

            if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

            const pageMarkup = await response.text();
            const nextDocument = new DOMParser().parseFromString(pageMarkup, 'text/html');
            const nextGrid = nextDocument.querySelector('#product-grid');
            if (!nextGrid) throw new Error('The next product page could not be found.');

            const nextItems = Array.from(nextGrid.querySelectorAll(':scope > .grid__item'));
            nextItems.forEach((item) => {
              placeItemInCategories(item);
            });
            sortMerchGrid();

            const nextLoadMore = nextDocument.querySelector('[data-catalog-load-more]');
            const nextPageUrl = nextLoadMore?.dataset.nextUrl;

            if (nextPageUrl) {
              loadMoreButton.dataset.nextUrl = nextPageUrl;
              loadMoreButton.disabled = false;
            } else {
              loadMoreWrapper.hidden = true;
            }

            if (loadStatus) loadStatus.textContent = `Loaded ${nextItems.length} more products.`;
          } catch (error) {
            loadMoreButton.disabled = false;
            if (loadStatus) loadStatus.textContent = 'Products could not be loaded. Please try again.';
          }
        });
        loadMoreButton.dataset.initialized = 'true';
      }
    }

    const productContainer = document.querySelector('#ProductGridContainer');
    if (productContainer && productContainer.dataset.catalogObserver !== 'true') {
      const observer = new MutationObserver(() => initializeCatalog(document));
      observer.observe(productContainer, { childList: true, subtree: true });
      productContainer.dataset.catalogObserver = 'true';
    }
  };

  const initialize = () => initializeCatalog(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initializeCatalog(event.target));
})();
